export default __webpack_public_path__ + "static/media/origin_white.51d54a83.png";